// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0a4f1e3e","644":"166da5a3","667":"c7179eb6"}[chunkId] + ".chunk.js";
};